import { FC, memo } from 'react'
import Link from 'next/link'
import { Flex } from '@chakra-ui/react'

import { GoBackButton, ModulesButton, ThemeToggleButton, UserButton } from 'components'
import InfoButton from 'components/navbarItems/InfoButton'

type Props = {
  goBackButton?: {
    name: string
    path: string
  }
}

const NavbarOnSidebarWithViews: FC<Props> = ({ goBackButton }) => {
  return (
    <Flex h="50px" w="full" bg="light" align="center" justify="space-between" px={2}>
      {goBackButton?.path && (
        <Flex gap={2} height="50px" alignItems="center" justifyContent="space-around">
          <Link href={goBackButton?.path}>
            <GoBackButton>{goBackButton?.name}</GoBackButton>
          </Link>
        </Flex>
      )}

      <Flex align="center" gap={2}>
        <InfoButton />
        <ModulesButton />
        <ThemeToggleButton />
        <UserButton />
      </Flex>
    </Flex>
  )
}

export default memo(NavbarOnSidebarWithViews)
